import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MultiYearScalarType } from '../../types';
import './styles.css';
import EconomicChart from '../EconomicChart';

class BalanceSheet extends Component {
	render() {
		const {
			balanceSheet: {
				cash,
				accountReceivables,
				totalRawMaterialInventory,
				finishedGoodsInventory,
				totalCurrentAssets,
				netFixedAssets,
				totalAssets,

				accountPayables,
				shortTermDebts,
				currentLiabilities,
				longTermDebt,
				totalLiabilities,
				equity,
				retainedEarnings,
				netIncome,
				totalEquity,
				totalLiabilitiesAndEquity
			}
		} = this.props.game;

		const dataAssets = [
			{ label: 'Cash', values: cash },
			{ label: 'Account receivables', values: accountReceivables },
			{
				label: 'Raw material inventory',
				values: totalRawMaterialInventory
			},
			{ label: 'Finished goods inventory', values: finishedGoodsInventory },
			{ label: 'Total current assets', values: totalCurrentAssets },
			{ label: 'Net fixed assets', values: netFixedAssets },
			{ label: 'Total Assets', values: totalAssets }
		];

		const dataLiabilities = [
			{ label: 'Account payables (total)', values: accountPayables },
			{ label: 'Short-term debt', values: shortTermDebts },
			{ label: 'Current liabilities', values: currentLiabilities },
			{ label: 'Long-term Debt', values: longTermDebt },
			{ label: 'Total liabilities', values: totalLiabilities },
			{ label: "Common stockholders' equity", values: equity },
			{ label: 'Reserves (Retained earnings)', values: retainedEarnings },
			{ label: 'Net Income', values: netIncome },
			{ label: 'Total equity', values: totalEquity },
			{
				label: 'Total liabilities and equity',
				values: totalLiabilitiesAndEquity
			}
		];

		return (
			<div className="income-statement">
				<span>Assets</span>
				<EconomicChart data={dataAssets} />
				<span>Liabilities & Equity</span>
				<EconomicChart data={dataLiabilities} />
			</div>
		);
	}
}

BalanceSheet.propTypes = {
	game: PropTypes.shape({
		id: PropTypes.string.isRequired,
		balanceSheet: PropTypes.shape({
			cash: MultiYearScalarType,
			accountReceivables: MultiYearScalarType,
			totalRawMaterialInventory: MultiYearScalarType,
			finishedGoodsInventory: MultiYearScalarType,
			totalCurrentAssets: MultiYearScalarType,
			netFixedAssets: MultiYearScalarType,
			totalAssets: MultiYearScalarType,

			accountPayables: MultiYearScalarType,
			shortTermDebts: MultiYearScalarType,
			currentLiabilities: MultiYearScalarType,
			longTermDebt: MultiYearScalarType,
			totalLiabilities: MultiYearScalarType,
			equity: MultiYearScalarType,
			retainedEarnings: MultiYearScalarType,
			netIncome: MultiYearScalarType,
			totalEquity: MultiYearScalarType,
			totalLiabilitiesAndEquity: MultiYearScalarType
		})
	})
};

export default BalanceSheet;
